import {
  ADD_CONTENT_REQUEST,
  ADD_CONTENT_SUCCESS,
  ADD_CONTENT_FAILURE,
  FETCH_CONTENT_REQUEST,
  FETCH_CONTENT_SUCCESS,
  FETCH_CONTENT_FAILURE,
  CLEAR_CONTENT,
} from "../Actions/contentActions";

export const contentUploadReducer = (
  state = { loading: false, success: false, error: null },
  action
) => {
  switch (action.type) {
    case ADD_CONTENT_REQUEST:
      return { loading: true };
    case ADD_CONTENT_SUCCESS:
      return { loading: false, success: true };
    case ADD_CONTENT_FAILURE:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};

export const contentFetchReducer = (
  state = { loading: false, contentList: [], error: null },
  action
) => {
  switch (action.type) {
    case FETCH_CONTENT_REQUEST:
      return { ...state, loading: true };
    case FETCH_CONTENT_SUCCESS:
      return { loading: false, contentList: action.payload };
    case FETCH_CONTENT_FAILURE:
      return { loading: false, error: action.payload };
    case CLEAR_CONTENT:
      return { loading: false, contentList: [], error: null };
    default:
      return state;
  }
};
